/* THE BLUEPRINT — Theme JS */

// Scroll-triggered reveals
document.addEventListener('DOMContentLoaded', function () {
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    reveals.forEach((el) => observer.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('in-view'));
  }

  // Hero watermark parallax
  const watermark = document.querySelector('.hero-watermark');
  if (watermark) {
    window.addEventListener('scroll', function () {
      watermark.style.transform = 'translateY(' + window.scrollY * 0.3 + 'px)';
    }, { passive: true });
  }

  // Cart: add to cart with feedback
  document.querySelectorAll('.book-add[data-product-id]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const id = this.getAttribute('data-product-id');
      const originalText = this.textContent;
      this.textContent = 'Adding...';
      this.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
        .then((r) => r.json())
        .then(() => {
          this.textContent = '✓ Added';
          this.style.background = 'var(--accent)';
          this.style.color = '#0b0a08';
          updateCartCount();
          setTimeout(() => {
            this.textContent = originalText;
            this.style.background = '';
            this.style.color = '';
            this.disabled = false;
          }, 1800);
        })
        .catch(() => {
          this.textContent = originalText;
          this.disabled = false;
        });
    });
  });

  // Manual add-to-cart buttons (no data-product-id — just visual feedback)
  document.querySelectorAll('.book-add:not([data-product-id])').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const orig = this.textContent;
      this.textContent = '✓ Added';
      this.style.background = 'var(--accent)';
      this.style.color = '#0b0a08';
      setTimeout(() => {
        this.textContent = orig;
        this.style.background = '';
        this.style.color = '';
      }, 1600);
    });
  });
});

function updateCartCount() {
  fetch('/cart.js')
    .then((r) => r.json())
    .then((cart) => {
      document.querySelectorAll('.cart-badge').forEach(function (badge) {
        badge.textContent = cart.item_count;
      });
    });
}
